export enum TrackEventNames {
  ApplicationForm = `Application Form Submission (New)`,
  ApplicationSubmittedIndividual = `Application_Submitted_Individual`,
  ApplicationSubmitted = `Application_Submitted`,
  ApplicationNext = `Next`
}

export enum ApplicationFormPaths {
  SelectAccountType = `SelectAccountType`,
  SelectPaymentMethod = `SelectPaymentMethod`,
  CreateLogIn = `CreateLogIn`,
  PersonalDetails = `PersonalDetails`,
  AddressDetails = `AddressDetails`,
  TaxDetails = `TaxDetails`,
  Employment = `Employment`,
  IdentityVerification = `IdentityVerification`,
  GlobalScreeningPepQuestions = `GlobalScreeningPepQuestions`,
  TermsAndConditions = `TermsAndConditions`,
  ApplicationSubmitted = `ApplicationSubmitted`,
  ApplicationSubmittedIndividual = `ApplicationSubmittedIndividual`
}
